import { ApiErrorDTO } from "@bvhi/backend-api/apis";
import { DialogContent, List, ListItem, ListItemText } from "@bvhi/ui-base";
import { useMemo } from "react";
import { useErrorObjectMapper } from "../hooks/use-error-object-mapper";

interface Props {
  customError?: string;
  error?: ApiErrorDTO;
  color?: "error" | "textPrimary";
}

export const DialogError = ({ error, customError, color = "textPrimary" }: Props) => {
  const { getErrorMessagesFromErrorObject } = useErrorObjectMapper();

  const renderedErrors = useMemo(() => {
    if (!error) return false;
    const errorMessages = getErrorMessagesFromErrorObject(error);
    if (errorMessages.length === 0) return undefined;

    return (
      <List dense>
        {errorMessages.map((error, index) => (
          <ListItem key={`error-dialog-${index}`} sx={{ pl: 0 }}>
            <ListItemText primary={error} primaryTypographyProps={{ color: color }} />
          </ListItem>
        ))}
        {customError && (
          <ListItem sx={{ pl: 0 }}>
            <ListItemText primary={customError} primaryTypographyProps={{ color: color }} />
          </ListItem>
        )}
      </List>
    );
  }, [error, getErrorMessagesFromErrorObject, color, customError]);

  if (!error) return false;
  if (!renderedErrors) return false;
  return <DialogContent>{renderedErrors}</DialogContent>;
};
